export const unitedStates = [
    {
        "itemValue": "Alabama",
        "itemLabel": "AL - Alabama"
    },
    {
        "itemValue": "Alaska",
        "itemLabel": "AK - Alaska"
    },
    {
        "itemValue": "American Samoa",
        "itemLabel": "AS - American Samoa"
    },
    {
        "itemValue": "Arizona",
        "itemLabel": "AZ - Arizona"
    },
    {
        "itemValue": "Arkansas",
        "itemLabel": "AR - Arkansas"
    },
    {
        "itemValue": "California",
        "itemLabel": "CA - California"
    },
    {
        "itemValue": "Colorado",
        "itemLabel": "CO - Colorado"
    },
    {
        "itemValue": "Connecticut",
        "itemLabel": "CT - Connecticut"
    },
    {
        "itemValue": "Delaware",
        "itemLabel": "DE - Delaware"
    },
    {
        "itemValue": "District Of Columbia",
        "itemLabel": "DC - District Of Columbia"
    },
    {
        "itemValue": "Federated States Of Micronesia",
        "itemLabel": "FM - Federated States Of Micronesia"
    },
    {
        "itemValue": "Florida",
        "itemLabel": "FL - Florida"
    },
    {
        "itemValue": "Georgia",
        "itemLabel": "GA - Georgia"
    },
    {
        "itemValue": "Guam",
        "itemLabel": "GU - Guam"
    },
    {
        "itemValue": "Hawaii",
        "itemLabel": "HI - Hawaii"
    },
    {
        "itemValue": "Idaho",
        "itemLabel": "ID - Idaho"
    },
    {
        "itemValue": "Illinois",
        "itemLabel": "IL - Illinois"
    },
    {
        "itemValue": "Indiana",
        "itemLabel": "IN - Indiana"
    },
    {
        "itemValue": "Iowa",
        "itemLabel": "IA - Iowa"
    },
    {
        "itemValue": "Kansas",
        "itemLabel": "KS - Kansas"
    },
    {
        "itemValue": "Kentucky",
        "itemLabel": "KY - Kentucky"
    },
    {
        "itemValue": "Louisiana",
        "itemLabel": "LA - Louisiana"
    },
    {
        "itemValue": "Maine",
        "itemLabel": "ME - Maine"
    },
    {
        "itemValue": "Marshall Islands",
        "itemLabel": "MH - Marshall Islands"
    },
    {
        "itemValue": "Maryland",
        "itemLabel": "MD - Maryland"
    },
    {
        "itemValue": "Massachusetts",
        "itemLabel": "MA - Massachusetts"
    },
    {
        "itemValue": "Michigan",
        "itemLabel": "MI - Michigan"
    },
    {
        "itemValue": "Minnesota",
        "itemLabel": "MN - Minnesota"
    },
    {
        "itemValue": "Mississippi",
        "itemLabel": "MS - Mississippi"
    },
    {
        "itemValue": "Missouri",
        "itemLabel": "MO - Missouri"
    },
    {
        "itemValue": "Montana",
        "itemLabel": "MT - Montana"
    },
    {
        "itemValue": "Nebraska",
        "itemLabel": "NE - Nebraska"
    },
    {
        "itemValue": "Nevada",
        "itemLabel": "NV - Nevada"
    },
    {
        "itemValue": "New Hampshire",
        "itemLabel": "NH - New Hampshire"
    },
    {
        "itemValue": "New Jersey",
        "itemLabel": "NJ - New Jersey"
    },
    {
        "itemValue": "New Mexico",
        "itemLabel": "NM - New Mexico"
    },
    {
        "itemValue": "New York",
        "itemLabel": "NY - New York"
    },
    {
        "itemValue": "North Carolina",
        "itemLabel": "NC - North Carolina"
    },
    {
        "itemValue": "North Dakota",
        "itemLabel": "ND - North Dakota"
    },
    {
        "itemValue": "Northern Mariana Islands",
        "itemLabel": "MP - Northern Mariana Islands"
    },
    {
        "itemValue": "Ohio",
        "itemLabel": "OH - Ohio"
    },
    {
        "itemValue": "Oklahoma",
        "itemLabel": "OK - Oklahoma"
    },
    {
        "itemValue": "Oregon",
        "itemLabel": "OR - Oregon"
    },
    {
        "itemValue": "Palau",
        "itemLabel": "PW - Palau"
    },
    {
        "itemValue": "Pennsylvania",
        "itemLabel": "PA - Pennsylvania"
    },
    {
        "itemValue": "Puerto Rico",
        "itemLabel": "PR - Puerto Rico"
    },
    {
        "itemValue": "Rhode Island",
        "itemLabel": "RI - Rhode Island"
    },
    {
        "itemValue": "South Carolina",
        "itemLabel": "SC - South Carolina"
    },
    {
        "itemValue": "South Dakota",
        "itemLabel": "SD - South Dakota"
    },
    {
        "itemValue": "Tennessee",
        "itemLabel": "TN - Tennessee"
    },
    {
        "itemValue": "Texas",
        "itemLabel": "TX - Texas"
    },
    {
        "itemValue": "Utah",
        "itemLabel": "UT - Utah"
    },
    {
        "itemValue": "Vermont",
        "itemLabel": "VT - Vermont"
    },
    {
        "itemValue": "Virgin Islands",
        "itemLabel": "VI - Virgin Islands"
    },
    {
        "itemValue": "Virginia",
        "itemLabel": "VA - Virginia"
    },
    {
        "itemValue": "Washington",
        "itemLabel": "WA - Washington"
    },
    {
        "itemValue": "West Virginia",
        "itemLabel": "WV - West Virginia"
    },
    {
        "itemValue": "Wisconsin",
        "itemLabel": "WI - Wisconsin"
    },
    {
        "itemValue": "Wyoming",
        "itemLabel": "WY - Wyoming"
    }
]